<template>
	<div>
		<navbar
			v-if="item"
			@reload="reload"
			:type="type"
			:item="item"
			:user="user"
			:isAuth="isAuth">
		</navbar>
		<template v-if="id">
			<template v-if="item">
				<router-view
					@reload="reload"
					:item="item"
					:user="user"
					:isAuth="isAuth">
				</router-view>
			</template>
		</template>
		<router-view
			v-else
			@reload="reload"
			:item="item"
			:user="user"
			:isAuth="isAuth">
		</router-view>
	</div>
</template>

<script>
	import Navbar from './../views/Navbar'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'navbar': Navbar,
		},
		data () {
			return {
				id: this.$route.params.id,
				item: null,
				type: 'standar',
			}
		},
		watch: {
			'$route'() {
				this.id = this.$route.params.id
				this.getData()
				this.loadType()
			}
		},
		created() {
			this.init()
		},
		methods: {
			init() {
				this.getData()
				this.loadType()
			},
			reload() {
				this.getData()
			},
			getData() {
				if(this.id) {
					this.$http.get('admin/projects/projects/' + this.id + '/get')
					.then(response => {
						this.item = response.body
					}).catch(function(response) {
						console.log(response)
					})
				} else {
					this.item = null
				}
			},
			loadType() {
				this.type = 'standar'
				if(this.$route.name == 'ProjectsShow') {
					this.type = 'show'
				}
				if(this.$route.name == 'ProjectsEdit') {
					this.type = 'edit'
				}
				if(this.$route.name == 'ProjectsIndex') {
					this.type = 'index'
				}
			}
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/projects/projects/layout/Projects.vue